import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldAlert, Lock, EyeOff } from 'lucide-react';

const PrivacyPage = () => {
  return (
    <div className="bg-[#F8FAFC] min-h-screen font-['Onest']">
        {/* Navbar Simple */}
      <nav className="bg-white border-b border-slate-100 h-20 flex items-center">
        <div className="container mx-auto px-6">
          <Link to="/" className="text-4xl font-semibold text-emerald-800">mikropedia</Link>
        </div>
      </nav>

      <main className="container mx-auto px-6 py-16">

      <div className="container mx-auto px-6 max-w-3xl">
        <div className="bg-white rounded-[2.5rem] border border-slate-100 p-8 md:p-16">
          <div className="flex items-center gap-4 mb-10">
            <div className="w-14 h-14 rounded-2xl bg-slate-900 text-white flex items-center justify-center">
              <Lock size={28} />
            </div>
            <div>
              <h1 className="text-3xl font-black text-slate-900">Kebijakan Privasi</h1>
              <p className="text-slate-400 font-bold text-xs uppercase tracking-widest">Terakhir diperbarui: April 2026</p>
            </div>
          </div>

          <article className="prose prose-slate max-w-none space-y-8 text-slate-600 leading-relaxed">
            <section>
              <h3 className="text-xl font-bold text-slate-900 mb-3">1. Informasi yang Kami Kumpulkan</h3>
              <p>Kami mengumpulkan informasi minimal untuk meningkatkan pengalaman Anda, seperti preferensi ide bisnis yang Anda simpan melalui <i>Local Storage</i> dan data anonim untuk analitik pengunjung.</p>
            </section>

            <section>
              <h3 className="text-xl font-bold text-slate-900 mb-3">2. Penggunaan Data</h3>
              <p>Data yang dikumpulkan digunakan semata-mata untuk:</p>
              <ul className="list-disc ml-5 space-y-2">
                <li>Menyediakan fitur pencarian ide bisnis yang dipersonalisasi.</li>
                <li>Menjaga fitur "Ide Tersimpan" tetap berfungsi di perangkat Anda.</li>
                <li>Menganalisis tren industri untuk memberikan konten yang lebih relevan.</li>
              </ul>
            </section>

            <section>
              <h3 className="text-xl font-bold text-slate-900 mb-3">3. Keamanan</h3>
              <p>Kami menggunakan infrastruktur keamanan dari Supabase untuk melindungi data yang tersimpan di server kami. Kami tidak pernah menjual data pribadi Anda kepada pihak ketiga.</p>
            </section>

            <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 italic">
              "Privasi Anda adalah komitmen kami. Mikropedia dirancang untuk memberikan inspirasi, bukan menginvasi privasi pengguna."
            </div>
          </article>
        </div>
      </div>
      </main>
    </div>
  );
};

export default PrivacyPage;